// extracted by mini-css-extract-plugin
export default {"main":"Home_main__0BVD9","image":"Home_image__hhLoI","logo":"Home_logo__ClF2Y","button":"Home_button__AcTH3"};